<template>
    <div class="container-fluid luminairs-selection-tool-container" :class="{'loading': loading}">
        <div class="row">
            <!-- SLIDER COL START -->
            <div class="col-md-6 order-md-2 col-lg-7 bg-dark m-0 p-0 lst-slider-wrapper">
                <luminaire-line-slider />
            </div>
            <!-- SLIDER COL END -->

            <!-- KONFIGURATOR COL START-->
            <div class="col-md-6 order-md-1 col-lg-5 vh-100 pe-4 bg-dark lst-filter-wrapper">

                <!-- HEADING -->
                <div class="container-fluid mb-4 px-0">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="featurette-heading text-white" v-if="product_configurator">{{ product_configurator.title }} {{ $t('configurator') }}</h2>
                        </div>
                    </div>
                </div>

                <!-- STEP NAVIGATION -->
                <luminaire-line-step-navigation
                    :product_configurator_id="product_configurator_id"
                    :current_step="current_step"
                    :clickableSteps="clickableSteps"
                    @update:current_step="updateCurrentStep" />

                <!-- PROJECT OVERVIEW -->
                <luminaire-line-project-overview
                    :product_configurator_id="product_configurator_id"
                    :generatedProductName="generatedProductName"
                    :generatedSku="generatedSku"
                    :calculatedProductPrice="calculatedProductPrice"
                    :finalPlanningPrice="finalPlanningPrice"
                    :luminaireLinePrices="luminaireLinePrices"
                    :displayLedModule="true"
                    :totalLuminationLength="this.luminaireLineFormFields.total_lumination_line_length"
                />

                <!-- Configurator Steps Content-->
                <div class="tab-content" id="configurator-steps-content">

                    <!-- LUMINAIRE SELECTION TOOL Step -->
                    <luminaire-selection-tool v-if="product_configurator_id === 1"
                        :product_configurator_id="product_configurator_id"
                        :current_step="current_step"
                        :validatedSteps="validatedSteps"
                        @update-loading="updateLoading"
                        @update-selected-serie="updateSelectedSerie"
                        @update-selected-control="updateSelectedControl"
                        @update-selected-housing-color="updateSelectedHousingColor"
                        @update-selected-optics="updateSelectedOptics"
                        @update-selected-optics-partial="updateSelectedOpticsPartial"
                        @update-individual-optic-selected="updateIndividualOpticSelected"
                        @update-selected-protection-class="updateSelectedProtectionClass"
                        @update-selected-options="updateSelectedOptions"
                        @update-generated-sku="updateGeneratedSku"
                        @update-generated-product-name="updateGeneratedProductName"
                        @update-luminaire-control-reset="luminaireControlReset"
                        @update-step-1-validated="updateValidatedSteps"
                        @update-luminaire-line-products="updateLuminaireLineProducts"
                        @update-lst-form="updateLstForm"
                        @update-all-luminaire-selection-steps-selected="updateAllLuminaireSelectionStepsSelected" />

                    <!-- LOGIN/CREATE PROJECT & PLANNING Step  -->
                    <luminaire-line-create-project
                        :product_configurator_id="product_configurator_id"
                        :current_step="current_step"
                        :projects="projects"
                        :planningCreated="planningCreated"
                        :planningFormErrors="planningFormErrors"
                        @update-step-2-validated="updateValidatedSteps"
                        @update-planning-form-fields="updatePlanningFormFields"
                        @get-projects="getProjects" />

                    <!-- LUMINAIRE LINE TOOL Step  -->
                    <luminaire-line-tool v-if="filteredLuminaireLineProducts"
                        :product_configurator_id="product_configurator_id"
                        :current_step="current_step"
                        :luminaireLineProducts="filteredLuminaireLineProducts"
                        :unfilteredProducts="products"
                        :lstForm="lstForm"
                        :planning_id="planning_id"
                        :planningFormFields="planningFormFields"
                        :generatedSku="generatedSku"
                        :generatedProductName="generatedProductName"
                        :calculatedProductPrice="calculatedProductPrice"
                        :selectedSerie="selectedSerie"
                        :selectedProtectionClass="selectedProtectionClass"
                        :isIndividualOpticSelected="isIndividualOpticSelected"
                        :selectedOpticsPartial="selectedOpticsPartial"
                        :editPlanning="false"
                        @update-ltt-form="updateLuminaireLineFormFields"
                        @update-final-planning-price="updateFinalPlanningPrice"
                        @update-luminaire-line-prices="updateLuminaireLinePrices"
                        @update-step-3-validated="updateValidatedSteps" />

                    <luminaire-line-form-navigation
                        :product_configurator_id="product_configurator_id"
                        :current_step="current_step"
                        :clickableSteps="clickableSteps"
                        :validatedSteps="validatedSteps"
                        :planningFormFields="planningFormFields"
                        :luminaireLineFormFields="luminaireLineFormFields"
                        :lstForm="lstForm"
                        :editPlanning="false"
                        :calculatedProductPrice="calculatedProductPrice"
                        :generatedSku="generatedSku"
                        :allLuminaireSelectionStepsSelected="allLuminaireSelectionStepsSelected"
                        @update-current-step="updateCurrentStep"
                        @update-loading="updateLoading"
                        @update-planning-form-errors="updatePlanningFormErrors"
                        @update-planning-created="updatePlanningCreated"
                        @set-planning-id="setPlanningId"
                        @get-projects="getProjects" />

                </div>
                <footer class="d-block d-md-none">
                    <p class="fs-6 py-2 px-4 m-0 text-center default-footer bg-dark text-white shadow">© {{ new Date().getFullYear() }} tempLED GmbH · <a href="https://templed.de/datenschutz/" target="_blank">{{ $t('Privacy policy') }}</a> · <a href="https://templed.de/impressum/" target="_blank">{{ $t('Imprint') }}</a> · Powered by <a href="https://des21.com/" target="_blank">des21</a></p>
                </footer>
            </div>
            <!-- KONFIGURATOR COL END -->

        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import { getFilteredLuminaireLineProductsExt } from "../../services/FilterProductsService";
    import { getLedPriceExt } from "../../services/LedPriceService";

    export default {
        data() {
            return {

                /**
                 * GENERAL DATA
                 **/
                product_configurator_id: null,
                product_configurator: null,
                loading: true,
                loadingError: false,
                current_step: 1,
                max_step: 1,
                validatedSteps: [],

                products: [],

            filteredLuminaireLineProducts: {},
            isIndividualOpticSelected: false,
            selectedOpticsPartial: null,

                /**
                 * LUMINAIRE SELECTION TOOL DATA
                 **/
                lstForm: {},
                selectedSerie: '',
                selectedControl: '',
                selectedHousingColor: '',
                selectedOptics: '',
                selectedProtectionClass: '',
                selectedOptions: '',
                generatedSku: '',
                generatedProductName: '',
                calculatedProductPrice: '',
                allLuminaireSelectionStepsSelected: false,

                /**
                 * PROJECT & PLANNING DATA
                 **/
                projects: {},
                projectFormFields: {},

                planningFormFields: {},
                planningCreated: false,
                planningFormErrors: {},

                planning_id: null,

                /**
                 * LUMINATION LINE DATA
                 **/

                luminaireLineProducts: {},

                luminaireLineFormFields: {},
                luminaireLineFormErrors: {},

                finalPlanningPrice: null,
                luminaireLinePrices: null,
                // Monotonic token used to ignore stale catalog responses.
                productsRequestToken: 0,

            }
        },

        created() {
            this.getProductConfigurator();
            this.loadProductsForLlt(); // Load products immediately for intelligence
        },

        methods: {

            getProductConfigurator() {
                this.loading = true;

                let slug = this.$route.params.id ? this.$route.params.id : window.location.pathname.replace('/', '');

                axios.get('/api/product_configurator/' + slug)
                    .then(response => {
                        this.product_configurator_id = response.data.data.id;
                        this.product_configurator = response.data.data;

                        // RayRail Addition
                        if (this.product_configurator_id === 3) {
                            this.getProjects();
                            this.updateSelectedSerie('eco');
                            this.updateSelectedHousingColor(3); // 3 = Aluminum bare
                            this.generatedProductName = 'tempLED RayRail';
                            this.validatedSteps.push(1);
                            this.current_step = 2;
                            this.max_step = 2;
                        }
                    }).catch(error => {
                    this.loadingError = error.response;
                });


            },

            /**************************************************************************
             * GENERAL METHODS
             **************************************************************************/

            goToStep(stepToGo) {

                let stepToGoToIsValidated = this.clickableSteps.includes(stepToGo);

                if ( stepToGoToIsValidated ) {
                    this.current_step = stepToGo;
                } else if ( stepToGo <= this.max_step ) {
                    this.current_step = stepToGo;
                }

            },

            goToTab(event, nextStepId) {
                $('#' + nextStepId + '-tab').tab('show');
            },

            /**************************************************************************
             * UPDATE STATES
             * StepNavigation, FormNavigation
             **************************************************************************/

            updateCurrentStep(value) {
                this.current_step = value;
            },

            updateLoading(value) {
                this.loading = value;
            },

            setPlanningId(value) {
                this.planning_id = value;
            },

            updatePlanningFormErrors(value) {
                this.planningFormErrors = value;
            },

            updatePlanningCreated(value) {
                this.planningCreated = value;
            },

            updateLuminaireLineProducts(value) {
                this.luminaireLineProducts = value;
            },

            updateAllLuminaireSelectionStepsSelected(value) {
                this.allLuminaireSelectionStepsSelected = value;
                console.log('All luminaire selection steps selected:', value);
            },

            updateValidatedSteps(value) {

                // Step 1
                if ( value === 'step_1_not_valid') {
                    this.validatedSteps = this.validatedSteps.filter(el => el !== 1);
                    // Cascade invalidation: If step 1 is invalid, subsequent steps are invalid too
                    this.validatedSteps = this.validatedSteps.filter(el => el !== 2);
                    this.validatedSteps = this.validatedSteps.filter(el => el !== 3);
                } else if (value === 'step_1_valid') {
                    this.validatedSteps.indexOf(1) === -1 ? this.validatedSteps.push(1) : console.log("This step already validated");
                }

                // Step 2
                if ( value === 'step_2_not_valid' ) {
                    this.validatedSteps = this.validatedSteps.filter(el => el !== 2);
                    // Cascade invalidation: If step 2 is invalid, step 3 is invalid too
                    this.validatedSteps = this.validatedSteps.filter(el => el !== 3);
                } else if (value === 'step_2_valid') {
                    this.validatedSteps.indexOf(2) === -1 ? this.validatedSteps.push(2) : console.log("This step already validated");
                }

                // Step 3
                if ( value === 'step_3_not_valid' ) {
                    this.validatedSteps = this.validatedSteps.filter(el => el !== 3);
                } else if (value === 'step_3_valid') {
                    this.validatedSteps.indexOf(3) === -1 ? this.validatedSteps.push(3) : console.log("This step already validated");
                }

                // tempLED RayRail has no step 1
                if (this.product_configurator_id === 3) {
                    this.validatedSteps.push(1);
                }

                // TESTING
                //this.validatedSteps.push(1);
                //this.validatedSteps.push(2);

            },

            /**************************************************************************
             * UPDATE STATES
             * LuminaireSelectionTool
             **************************************************************************/

            updateLstForm(value) {
                this.lstForm = value;
            },
            updateSelectedSerie(value) {
                this.selectedSerie = value;
            },
            updateSelectedControl(value) {
                this.selectedControl = value;
            },
            updateSelectedHousingColor(value) {
                this.selectedHousingColor = value;
            },
            updateSelectedOptics(value) {
                this.selectedOptics= value;
            },
            updateSelectedOpticsPartial(value) {
                this.selectedOpticsPartial = value;
            },
            updateIndividualOpticSelected(value) {
                this.isIndividualOpticSelected = value;
            },
            updateSelectedProtectionClass(value) {
                this.selectedProtectionClass = value;
            },
            updateSelectedOptions(value) {
                this.selectedOptions = value;
            },
            updateGeneratedSku(value) {
                getLedPriceExt.bind(this)(value);
            },
            updateGeneratedProductName(value) {
                this.generatedProductName = value;
            },
            luminaireControlReset(value) {
                if (value) {
                    this.luminaireLineFormFields.number_of_luminaire_controls = 0;
                    this.luminaireLineFormFields.type_of_luminaire_controls = '';

                    this.luminaireLineFormFields.number_of_luminaire_control_slaves = 0;
                    this.luminaireLineFormFields.type_of_luminaire_control_slaves = '';
                }
            },

            /**************************************************************************
             * UPDATE STATES
             * CreateProject
             **************************************************************************/
            updatePlanningFormFields(value) {
                this.planningFormFields = value;
            },

            /**************************************************************************
             * UPDATE STATES
             * LuminaireLineTool
             **************************************************************************/
            updateLuminaireLineFormFields(value) {
                this.luminaireLineFormFields = value;
            },
            updateFinalPlanningPrice(value) {
                this.finalPlanningPrice = value;
            },
            updateLuminaireLinePrices(value) {
                this.luminaireLinePrices = value;
            },

            /**************************************************************************
             * PROJECT METHODS
             **************************************************************************/

            getProjects() {
                if ( this.current_step !== 1 ) this.loading = true;
                axios.get('/api/projects?paginate=0&only_open=1')
                    .then(response => {
                        this.projects = response.data.data;
                        this.loading = false;
                    }).catch(error => {
                        console.log(error);
                        this.loading = false;
                    });
            },

            loadProductsForLlt() {
                // Always load the full catalog; IP55 filtering is handled
                // entirely by FilterProductsService on the frontend side.

                // Guard against out-of-order async responses when series/protection
                // changes trigger multiple catalog requests in quick succession.
                this.productsRequestToken += 1;
                const requestToken = this.productsRequestToken;

                axios.get('/api/luminaire_line_products?group_by=product_type')
                    .then(response => {
                        if (requestToken !== this.productsRequestToken) {
                            return;
                        }

                        this.products = this.extractCatalogGroups(response?.data || {});
                        this.getFilteredLuminaireLineProducts();
                    })
                    .catch(error => {
                        if (requestToken !== this.productsRequestToken) {
                            return;
                        }
                        console.log(error);
                    });
            },

            extractCatalogGroups(payload) {
                if (
                    payload
                    && typeof payload === 'object'
                    && payload.data
                    && typeof payload.data === 'object'
                    && !Array.isArray(payload.data)
                ) {
                    return payload.data;
                }

                return payload || {};
            },


            getFilteredLuminaireLineProducts() {

                this.filteredLuminaireLineProducts = getFilteredLuminaireLineProductsExt(this);

            },

        },

        computed: {

            ...mapGetters({
                authenticated: 'auth/authenticated',
                user: 'auth/user',
                permissions: 'auth/permissions'
            }),

            /**
             * GENERAL COMPUTED
             **/

            clickableSteps() {

                let clickableSteps = [];

                // all validated Steps are clickable

                clickableSteps = clickableSteps.concat(this.validatedSteps);
                // Current Step is clickable
                if ( clickableSteps.indexOf(this.current_step) === -1 ) {
                    clickableSteps.push(this.current_step);
                }

                // if current step is validated, next step get clickable
                if ( this.validatedSteps.includes(this.current_step) ) {
                    if ( clickableSteps.indexOf(this.current_step + 1) === -1 ) clickableSteps.push(this.current_step +1);
                }

                // if current step is not validated & current step is 2 or 3 -> previous step is clickable -> GO BACK one Step
                if ( !this.validatedSteps.includes(this.current_step) && this.current_step > 1 ) {
                    if ( clickableSteps.indexOf(this.current_step - 1 ) === -1) clickableSteps.push(this.current_step -1 );
                }

                // if step max step = 3 & step 1 & 2 validated -> step 3
                if (this.max_step === 3 && this.validatedSteps.includes(1) && this.validatedSteps.includes(2)) {
                    if ( clickableSteps.indexOf(3) === -1 ) clickableSteps.push(3);
                }

                // Set max step to highest current step
                if ( this.max_step < this.current_step ) {
                    this.max_step = this.current_step;
                }

                return clickableSteps;
            },

        },

        watch: {
            selectedSerie: function(value) {

                this.loadProductsForLlt();
                if (this.authenticated) {
                    this.getProjects();
                }
            },

            generatedSku: function(value) {
                if (value) {
                    this.getFilteredLuminaireLineProducts();
                }
            },

            selectedProtectionClass: function() {
                this.loadProductsForLlt();
            },

            authenticated: function(value) {
                this.getProjects();
            },

        },
    }
</script>
